module.exports = new __parcel__URL__("relief_monthly_max_ssp126.5e5726f6.png").toString();